
import FileResultCard from './FileResultCard.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IFileStructure } from '@/types/resource.types';

@Component({
    name: 'FileUnknownData',
    components: {
        FileResultCard
    }
})
export default class FileUnknownData extends Vue {

    /* Props
    ============================================*/

    @Prop({type: Array, required: true, default: () => []})
    readonly structures: IFileStructure[];

}

